module.exports = __webpack_public_path__ + "assets/img/D-fdf81aaf.png";